module.exports = __webpack_public_path__ + "img/GM.e63ab173.svg";